const style = {
  inputGroup: {
    margin: `5px -15px`
  },
  checkbox: {
    display: `block`,
    width: `9px`,
    height: `9px`,
    border: `1px solid #ad5151`
  },
  checkbox_check: {
    background: `#ad5151`
  },
  input: {
    padding: `5px 15px`,
    height: `40px`,
    width: `100%`,
    border: `1px solid #ddd`,
    background: `#fff`,
    borderRadius: `0px`,
    fontSize: `14px`
  },
  select: {
    borderRadius: 0,
    '-webkit-appearance': `none`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Community/partials/CommunityCreator/style/form.js